import { getBrandConfig } from './brands';

export const BRAND_ID = import.meta.env.VITE_BRAND_ID as string | undefined;

export const currentBrand = getBrandConfig(BRAND_ID);

export function applyBrandTheme() {
  const root = document.documentElement;
  Object.entries(currentBrand.cssVars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });

  let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = currentBrand.faviconUrl;

  document.title = currentBrand.metaTitle;
}
